import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ThemeProvider } from '@mui/material/styles'
import { Grid, CssBaseline, StyledEngineProvider } from '@mui/material'
import Routes from './routes'
import themes from './config/themes'
import { NavigationScroll } from './components/Main'
import { InteractorAuthorization, InteractorSummaryHeader } from './interactors/Main'
import { Loading } from './components/Main'
import { ShowLoading } from './redux/loading/actionCreator'
import { getCookies } from './utility/Cookies'
import FirebaseNotification from './firebase/FirebaseNotification'

const App = () => {
  const { token } = InteractorAuthorization()
  const { loading } = useSelector((state) => state.loading)
  const { seller } = useSelector((state) => state.seller)
  const { account } = useSelector((state) => state.account)
  const dispatch = useDispatch()
  const customization = useSelector((state) => state.customization)
  const { summaryHeader } = InteractorSummaryHeader()

  useEffect(() => {
    if (!getCookies('_wide')) {
      dispatch(ShowLoading())
      token()
    }
    if (account && account.account_type !== 'SELLER') {
      window.location.href = process.env.REACT_APP_DOMAIN_MARKETPLACE
    }
    if (seller && !getCookies('wsc-summary-header')) {
      summaryHeader()
    }
  }, [account, dispatch, seller, summaryHeader, token])

  return (
    <>
      {loading ? (
        <Grid container justifyContent="center" alignItems="center" minHeight="100vh">
          <Loading />
        </Grid>
      ) : (
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={themes(customization)}>
            <CssBaseline />
            <NavigationScroll>
              <Routes />
            </NavigationScroll>
            {seller && <FirebaseNotification />}
          </ThemeProvider>
        </StyledEngineProvider>
      )}
    </>
  )
}

export default App
